Vendd.Scripts.load(function () {
    var $form = $('.x-newsletter-form');

    if ($form.length < 1)
        return;

    $.each($form, function (i, form) {
        var $this = $(form),
            $button = $('.js-submit', $this),
            $categoriesWrapper = $('.newsletter-categories-wrapper', $this);

        var formData = {
            email: "",
            subscriptionType: "NewsletterForm",
            apiKey: "793c8798-df3d-440c-a195-9a973a9f508e",
            mailparams: "",
            mailLists: []
            //mailLists: {
            //    Action: 0, //subscribe action
            //    MailListId: "",
            //    Provider: 1 //mailchimp provider
            //}
        };

        $this.validationEngine({
            email: {
                required: 'email-required',
                isEmail: 'email-invalid'
            }
        });

        var va = $this.data('validationEngine'),
            messageTiming = 3500;

        form.loading = function (option) {
            if (option) {
                $this.addClass('x-loading');
                $button.attr("disabled", "disabled");
                return;
            }

            $this.removeClass('x-loading');
            $button.removeAttr("disabled");
        };

        form.onSuccess = function (envelope) {
            var response = envelope.message.data;

            if (!$this.hasClass('x-loading'))
            	return;

            form.loading(false);
            form.reset();

            $('.js-success', $this).removeClass('js-visible');

            if (response.success) {
                $('.js-content', $this).hide();
                $('.js-success', $this).html(response.data + '<span class="email">' + response.email + '</span>').addClass('js-visible');
            } else {
                if (response.code && response.code === 'Newsletter_AlreadySubscribed') {

                    $('.js-alreadysubscribed', $this).addClass('js-visible');

                    setTimeout(function () {
                        $('.js-alreadysubscribed', $this).removeClass('js-visible');
                    }, messageTiming);
                } else {
                    $('.js-generic-error', $this).addClass('js-visible');

                    setTimeout(function () {
                        $('.js-generic-error', $this).removeClass('js-visible');
                    }, messageTiming);
                }
            }
        };

        form.onFailure = function (envelope) {
            form.loading(false);
            form.reset();

            $('.form-result', $this).removeClass('js-visible');
            $('.js-generic-error', $this).addClass('js-visible');

            setTimeout(function () {
                $('.js-generic-error', $this).removeClass('js-visible');
            }, messageTiming);
        };

        form.submit = function () {
            form.loading(true);
            formData.email = $('input[name="email"]', $this).val(); 
            Vendd.MessageBus.publishAsync(form, new Vendd.Newsletter.Messages.Subscribe(formData.email, formData.subscriptionType, '', formData.mailparams, formData.mailLists, formData.apiKey));
        };

        form.reset = function () {
            //reset mailLists Array
            formData.mailLists = [];
            //reset input mail
            $('input[name="email"]', $this).val("");
            //reset mailLists Selection
            $('.js-category', $categoriesWrapper).removeClass('selected');
            //reset Selected Categories
            $('.selected-categories', $categoriesWrapper).addClass('hidden');
            $('.selected-categories .count', $categoriesWrapper).text($('.js-category.selected', $categoriesWrapper).length);
        };

        $categoriesWrapper.on('click', '.js-categories-trigger', function (e) {

            var $categoriesList = $('.newsletter-categories-list', $categoriesWrapper);

            if ($categoriesList.hasClass('hidden')) {
                $categoriesList.removeClass('hidden');
            } else {
                $categoriesList.addClass('hidden');
            }
        });

        $categoriesWrapper.on('click', '.js-category', function (e) {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            } else {
                $(this).addClass('selected');
            }

            if ($('.js-category.selected', $categoriesWrapper).length > 0) {
                $('.selected-categories', $categoriesWrapper).removeClass('hidden');
            } else {
                $('.selected-categories', $categoriesWrapper).addClass('hidden');              
            }
            $('.selected-categories .count', $categoriesWrapper).text($('.js-category.selected', $categoriesWrapper).length);
        });

        $(document).on('click', function (e) {
            if (!$categoriesWrapper.is(e.target) && $categoriesWrapper.has(e.target).length === 0) {
                if (!$('.newsletter-categories-list', $categoriesWrapper).hasClass('hidden')) {
                    $('.newsletter-categories-list', $categoriesWrapper).addClass('hidden');
                }
            }
        });

        $this.on('click', '.js-submit', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $('.js-category', $categoriesWrapper).each(function (index) {
                if ($(this).hasClass('selected')) {
                    var mailList = {
                        Action: 0, //subscribe action
                        MailListId: $(this).data('category-id'),
                        Provider: 1 //mailchimp provider
                    };
                    formData.mailLists.push(mailList);
                }
            });

            if ($this.hasClass('pop-up'))
                formData.isPopUp = true;

            if (va.validate())
                form.submit();              
        });

        $this.on('keyup', 'input[name="email"]', function (e) {

            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();

                $button.click();

                return;
            }

            va.validate('email');
        });

        $this.on('blur', 'input[name="email"]', function (e) {
            setTimeout(function () {
                $('.validator', $form).removeClass('error');
            }, messageTiming);
        });

        Vendd.MessageBus.subscribe(Vendd.Newsletter.Messages.SubscribeSuccess, form, form.onSuccess);
        Vendd.MessageBus.subscribe(Vendd.Newsletter.Messages.SubscribeFailure, form, form.onFailure);
    });
});